export const Sex = { 2: '男', 1: '女' };
